import React from "react";
import { useLocation, useNavigate } from "react-router";
import PublicPageHeader from "../../components/PublicPageHeader";
import Currency from "../../components/currency";
import CurrencyFormat from "../../components/currencyFormat/currencyFormat";
import { RoutesPaths } from "../../Router/constant";

export default function PayNowFallbackStatus({ status }) {
  const navigate = useNavigate();
  const location = useLocation();
  const pathnames = location?.pathname?.split("/").filter((x) => x);
  const searchParams = new URLSearchParams(location.search);
  const planId = pathnames?.[0] === "pay" ? pathnames?.[1] : searchParams.get("planId");
  const orderNo = searchParams.get("orderNo")?.trim().replace(/^['"]|['"]$/g, "");
  const isSuccess = status === "success";
  const amount = searchParams.get("amount");
  const currency = searchParams.get("currency");

  const viewDetails = () => {
    if (planId) {
      navigate(RoutesPaths.PUBLIC_PAYMENT_STATUS.replace(":slug", planId));
      return;
    }

    navigate(RoutesPaths.LANDING_PUBLIC);
  };

  const tryAgain = () => {
    if (planId) {
      navigate(RoutesPaths.PAY_BANKTRANSFER_PUBLIC.replace(":slug", planId));
      return;
    }

    navigate(RoutesPaths.LANDING_PUBLIC);
  };

  return (
    <div className="quotationPreviewWrapper">
      <PublicPageHeader />
      <div className="container bankPage mt-4">
        <div className="row buyProductSection">
          <div className="col-md-8">
            <div className="container p-2">
              <div className="buyProductSectionBgPayout">
                <div className="transferAmount">
                  {isSuccess ? (
                    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="36" cy="36" r="36" fill="#23A26D" fillOpacity="0.12" />
                      <path d="M36.4987 19.333C27.3154 19.333 19.832 26.8163 19.832 35.9997C19.832 45.183 27.3154 52.6663 36.4987 52.6663C45.682 52.6663 53.1654 45.183 53.1654 35.9997C53.1654 26.8163 45.682 19.333 36.4987 19.333ZM44.4654 32.1663L35.0154 41.6163C34.782 41.8497 34.4654 41.983 34.132 41.983C33.7987 41.983 33.482 41.8497 33.2487 41.6163L28.532 36.8997C28.0487 36.4163 28.0487 35.6163 28.532 35.133C29.0154 34.6497 29.8154 34.6497 30.2987 35.133L34.132 38.9663L42.6987 30.3997C43.182 29.9163 43.982 29.9163 44.4654 30.3997C44.9487 30.883 44.9487 31.6663 44.4654 32.1663Z" fill="#23A26D" />
                    </svg>
                  ) : (
                    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="36" cy="36" r="36" fill="#FEF2F2" />
                      <rect x="16.5" y="16" width="40" height="40" rx="20" fill="#9C1515" />
                      <path d="M39.0013 33.5003L34.0013 38.5003M34.0013 33.5003L39.0013 38.5003M44.8346 36.0003C44.8346 40.6027 41.1037 44.3337 36.5013 44.3337C31.8989 44.3337 28.168 40.6027 28.168 36.0003C28.168 31.398 31.8989 27.667 36.5013 27.667C41.1037 27.667 44.8346 31.398 44.8346 36.0003Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </div>
                <div className="paymentPersonName">
                  <h4>{isSuccess ? "Payment successful" : "Payment failed"}</h4>
                  <p>
                    {isSuccess
                      ? "Thanks, your PayNow payment has been received."
                      : "Your PayNow payment could not be completed. Please try again or contact support if the amount was deducted."}
                  </p>
                </div>
                {(orderNo || amount || currency) && (
                  <div className="paymentStatusHolder">
                    <h5>Payment summary</h5>
                    <div className="paymentStatusHeader">
                      {orderNo && (
                        <div className="rowHolder">
                          <p>Order ID</p>
                          <p className="rightText">{orderNo}</p>
                        </div>
                      )}
                      {amount && (
                        <div className="rowHolder">
                          <p>Amount</p>
                          <p className="amountText">
                            <Currency currency={currency || ""} />
                            <CurrencyFormat currency={currency} value={parseFloat(amount)} decimal={2} />
                          </p>
                        </div>
                      )}
                      <div className="rowHolder m-0">
                        <p>Status</p>
                        <div className={`statusBadge ${isSuccess ? "" : "notPaid"}`}>
                          <p>{isSuccess ? "Success" : "Failed"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row mb-4">
                {!isSuccess && (
                  <div className="col-4">
                    <div onClick={tryAgain} className="gobackButton">
                      <p className="m-0">Try again</p>
                    </div>
                  </div>
                )}
                <div className={isSuccess ? "col-12" : "col-8"}>
                  <div onClick={viewDetails} className="gobackButton continueButton">
                    <p className="m-0">{planId ? "View details" : "Back to home"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
